module.exports = __webpack_public_path__ + "images/background/image_thumbnail/6-on-8bfc3a3fc42e04974a5ab3691d40605e.jpg";